"use client"
import { iconsMap } from "@/public/icons/iconsMap"
import { sizes } from "@/ui/theme/theme"
import styled from "@emotion/styled"
import { Link } from "@mui/material"
import React from "react"
import { getNonUmbracoUrl } from "utils"

interface InfoLinkProps {
  href: string
  children?: React.ReactNode
  className?: string
  target?: "_blank" | "_self" | "_parent" | "_top"
  onClick?: () => void
}

const StyledInfoLink = styled(Link)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${sizes.baseSingle};
`

export const InfoLink: React.FC<InfoLinkProps> = ({
  href,
  children,
  className = "",
  target = "_self",
  onClick,
}) => {
  const InfoIcon = iconsMap["info"]
  return (
    <StyledInfoLink
      href={getNonUmbracoUrl(href)}
      target={target}
      className={className}
      onClick={onClick}
    >
      <InfoIcon />
      {children}
    </StyledInfoLink>
  )
}

export default InfoLink
